// Rows for the manager guest-list CSV export. Keys become the CSV headers
// (ExportToCsv is configured with useKeysAsHeaders).
//
// formatTimestamp turns an ISO timestamp into a human string; the component
// injects a moment-backed formatter so the date matches the rest of the event
// UI. Defaults to identity so the function stays pure and testable.
export function guestListRows(event, formatTimestamp = (v) => v) {
  return (event.event_rsvps || [])
    .map(rsvp => {
      const user = rsvp.user || {}
      return {
        Name: safeCell(rsvp.user ? user.display_name : `User #${rsvp.user_id}`),
        Email: safeCell(user.email || ''),
        Phone: safeCell(user.phone || ''),
        RSVP: rsvpLabel(rsvp),
        'Responded On': rsvp.last_responded_at ? formatTimestamp(rsvp.last_responded_at) : '',
      }
    })
    .sort((a, b) => a.Name.localeCompare(b.Name))
}

// A leading =, +, -, @, tab, or CR makes Excel/Sheets evaluate the cell as a
// formula (CSV injection); a leading apostrophe forces it to read as text.
function safeCell(value) {
  return /^[=+\-@\t\r]/.test(value) ? `'${value}` : value
}

function rsvpLabel(rsvp) {
  if (!rsvp.responded) return 'No response'
  return rsvp.attending ? 'Going' : 'Not Going'
}
